<template>
    <teleport to="body">
        <Modal
            :is-open="show"
            :title="`${sourceProgram} to ${destinationProgram} Transfer Instructions`"
            @close="closeModal()"
        >
            <template #content>
                <div
                    class="flex-col h-full w-full justify-start items-start gap-2 flex"
                >
                    <div class="items-start md:p-8 bg-white w-full">
                        <div v-show="loading">
                            <LoadingState :loading="loading" />
                        </div>
                        <div
                            v-show="!loading"
                            class="md:aspect-video aspect-square"
                            v-html="iframe"
                        ></div>
                    </div>
                </div>
            </template>
        </Modal>
    </teleport>
</template>
<script>
import LoadingState from '@/components/ui/loading-state/loading-state.vue';
import Modal from '@/components/ui/modal/ui-modal.vue';

import {
    Popover,
    PopoverButton,
    PopoverPanel,
    PopoverOverlay,
} from '@headlessui/vue';
export default {
    components: {
        LoadingState,
        Modal,
        Popover,
        PopoverButton,
        PopoverPanel,
        PopoverOverlay,
    },
    props: {
        iframe: String,
        sourceProgram: String,
        destinationProgram: String,
        loading: Boolean,
        show: Boolean,
    },
    emits: ['close'],
    setup(_, { emit }) {
        const closeModal = () => {
            emit('close');
        };
        return { closeModal };
    },
};
</script>
